import type { QueryError } from "./AnalyticsActions";
import { QUERY_ERROR } from "./AnalyticsActionTypes";

export type ResultType = "json" | "text";

export interface ExecutionResult {
	data: any;
	type: ResultType;
}

export class AnalyticsQuery {
	public readonly query: string = "";

	constructor(query = "") {
		this.query = query;
	}

	withResult(result: QueryError | ExecutionResult): AnalyticsQueryWithResult {
		if (result.type === QUERY_ERROR) {
			return new AnalyticsQueryWithErrors(this.query, Date.now(), result.error);
		}
		return new AnalyticsQueryWithData(this.query, Date.now(), result);
	}
}

export interface AnalyticsQueryWithResult {
	query: string;
	timestamp: number;
	getResult(): string;
	getResultType(): ResultType;
	toJson(): any;
}

class AnalyticsQueryWithErrors implements AnalyticsQueryWithResult {
	public readonly query: string;

	public readonly timestamp: number;

	private readonly result: string;

	constructor(query: string, timestamp: number, result: string) {
		this.result = result;
		this.timestamp = timestamp;
		this.query = query;
	}

	getResult(): string {
		if (this.result) {
			return `Error: ${this.result}`;
		}
		return "Unknown error occurred.";
	}

	getResultType(): ResultType {
		return "text";
	}

	toJson() {
		return {
			query: this.query,
			timestamp: this.timestamp,
			result: this.result,
		};
	}
}

class AnalyticsQueryWithData implements AnalyticsQueryWithResult {
	public readonly query: string;
	public readonly timestamp: number;
	private readonly result: ExecutionResult;

	constructor(query: string, timestamp: number, result: ExecutionResult) {
		this.query = query;
		this.timestamp = timestamp;
		this.result = result;
	}

	getResult(): string {
		// Format data as json
		return JSON.stringify(this.result.data, null, 2);
	}

	getResultType(): ResultType {
		return this.result.type;
	}

	toJson() {
		return {
			query: this.query,
			timestamp: this.timestamp,
			result: this.result,
		};
	}
}
